import { useCallback, useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

/** Dry-run of the CID embedding for the current (unsaved) template HTML. */
export function useCidAnalysis(htmlContent, previewUserId) {
  const [analysis, setAnalysis] = useState(null);
  const [analyzing, setAnalyzing] = useState(false);
  const requestId = useRef(0);

  useEffect(() => {
    requestId.current += 1;
    setAnalysis(null);
    setAnalyzing(false);
  }, [htmlContent, previewUserId]);

  const analyze = useCallback(async () => {
    const current = ++requestId.current;
    setAnalyzing(true);
    try {
      const { data } = await api.post("/signatures/cid-analyze", {
        html_content: htmlContent, user_id: previewUserId || undefined,
      });
      if (current === requestId.current) setAnalysis(data);
    } catch (e) {
      if (current === requestId.current) toast.error(formatApiError(e, "No se pudieron analizar las imágenes"));
    } finally {
      if (current === requestId.current) setAnalyzing(false);
    }
  }, [htmlContent, previewUserId]);

  return { analysis, analyzing, analyze };
}
